module.exports = __webpack_public_path__ + "img/icon-ekyc-detail-identity-card.61c0862.svg";